import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PatientContext {
    partnerProjectId?: string;
    currentConsultationId?: string;
    totalConsultationCount?: number;
}

interface PatientContextState {
    context: PatientContext | null;
}

const initialState: PatientContextState = {
    context: null,
};

const patientContextSlice = createSlice({
    name: 'patientContext',
    initialState,
    reducers: {
        setPatientContext: (state, action: PayloadAction<PatientContext | null>) => {
            state.context = action.payload;
        },
    },
});

export const { setPatientContext } = patientContextSlice.actions;
export const patientContextReducer = patientContextSlice.reducer;
